var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.feedback.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"2"}}):_vm._e(),_vm._v(" "),_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("#"+_vm._s(_vm.feedback.id)+" - "+_vm._s(_vm.feedback.admin.nickname))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('stars',{attrs:{"note":_vm.feedback.note}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a563fbb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackHeader.vue
// module id = null
// module chunks = 